import type { ModelProductLimit } from '@app/api/Products';

import type { BaseOptionType } from 'antd/es/select';

export interface FilterProductLimitsParams {
  search: string;
  categories: BaseOptionType[];
  categoryValueToLabel: Map<unknown, string>;
}

export const filterProductLimits = (
  rows: ModelProductLimit[],
  { search, categories, categoryValueToLabel }: FilterProductLimitsParams
): ModelProductLimit[] => {
  const s = search.trim().toLowerCase();

  const selectedCategoryLabels = categories
    .map((c) => categoryValueToLabel.get(c?.value))
    .filter((label): label is string => label != null);

  return rows.filter((r) => {
    const haystack = [
      r.Name,
      r.NameShort,
      r.Article,
      r.BarCode,
      r.Category,
    ].map((x) => String(x ?? '').toLowerCase());
    const passSearch = s ? haystack.some((t) => t.includes(s)) : true;
    const passCat =
      selectedCategoryLabels.length === 0
        ? true
        : selectedCategoryLabels.includes(String(r.Category ?? ''));
    return passSearch && passCat;
  });
};
